import PropTypes from "prop-types";
import React from "react";
import { appendClassName } from "./view-helpers";

function Results(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return React.createElement("ul", {
    className: appendClassName("sui-results-container", className)
  }, children);
}

Results.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
export default Results;